import { c } from 'ttag';

import { refusalCode } from '../../graphql/refusalCode';
import { Refusal } from '../accounts/portalAccess';

/**
 * Reading of the refusals of `deleteUser`. CANNOT_DELETE_SELF is the only one specific to this
 * gesture; the screen already hides the button on the actor's own sheet, so this catches a forced
 * mutation.
 */
export const deleteUserRefusalOf = (error: unknown): Refusal => {
    switch (refusalCode(error)) {
        case 'CANNOT_DELETE_SELF':
            return {
                title: c('Delete user refusal').t`You cannot delete your own account.`,
                guidance: c('Delete user refusal')
                    .t`Deleting yourself would cut your own access. Have another administrator do it if it must be done.`,
            };
        case 'MISSING_PERMISSION':
            return {
                title: c('Delete user refusal').t`Your role does not let you manage users.`,
                guidance: c('Delete user refusal')
                    .t`Deleting a user is a user-administration act. Ask an administrator, or have your role widened.`,
            };
        case 'FORBIDDEN_OUT_OF_SCOPE':
            return {
                title: c('Delete user refusal').t`This user reaches beyond your portfolio.`,
                guidance: c('Delete user refusal')
                    .t`They belong to at least one account outside what you may manage, and deleting them would remove that access too. Someone with the wider perimeter must do it.`,
            };
        case 'USER_NOT_FOUND':
            return {
                title: c('Delete user refusal').t`This user no longer exists.`,
                guidance: c('Delete user refusal')
                    .t`They may have just been deleted. Go back to the list to read it as it stands.`,
            };
        default:
            return {
                title: c('Delete user refusal').t`The user could not be deleted.`,
                guidance: c('Delete user refusal')
                    .t`Nothing was deleted. If it keeps refusing, pass the sentence below on to your Freelance.com contact.`,
            };
    }
};
